module.exports = __webpack_public_path__ + "static/media/tool.344ba0cd.PNG";